import { createContext, useContext, useMemo, useState } from 'react';
import type { ReactNode } from 'react';

type AgentPanel = { open: boolean; setOpen: (open: boolean | ((current: boolean) => boolean)) => void };

const AgentPanelContext = createContext<AgentPanel>({ open: false, setOpen: () => {} });

export function AgentPanelProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const value = useMemo(() => ({ open, setOpen }), [open]);
  return <AgentPanelContext.Provider value={value}>{children}</AgentPanelContext.Provider>;
}

export const useAgentPanel = () => useContext(AgentPanelContext);
